import { useState } from 'react';
import Nav from '../sections/Nav';
import Team from '../sections/Team';
import Footer from '../sections/Footer';
import ContactForm from '../ContactForm';
import { useSEO } from '../useSEO';

const TeamPage = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [contactFormMode, setContactFormMode] = useState('contact');

  useSEO({
    title: 'Team | Nthra Labs',
    description: 'Meet the founders of Nthra Labs — engineers, entrepreneurs, and domain experts building continuous conformance infrastructure for global manufacturing.',
    path: '/team',
  });

  const openContactForm = (mode) => {
    setContactFormMode(mode);
    setIsContactFormOpen(true);
  };

  return (
    <div style={{ fontFamily: "'DM Sans',sans-serif", background: '#ffffff', color: '#1a1a1a', minHeight: '100vh' }}>
      <Nav onOpenContact={openContactForm} />
      <h1 className="sr-only">Our Team — Nthra Labs Founders</h1>
      <div style={{ paddingTop: 24 }} />
      <Team />
      <Footer />
      <ContactForm
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
        mode={contactFormMode}
      />
    </div>
  );
};

export default TeamPage;
